import contactScene from "./assets/contact-scene.avif?url"

export default [
  {
    name: "contact-scene",
    type: "texture",
    path: contactScene,
  },
]
